/**
 * List Schema of CargaMedlog
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {CargaMedlog} from '@/model/resource/CargaMedlog'

/* TODO: review generated schema */
export class ListCargaMedlogSchema extends Schema {
  readonly name = 'ListCargaMedlog'

  readonly fieldSet: FieldSet<CargaMedlog> = {
    idCargaMedlogPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    carga: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.carga?.$id,
      },
    }),
    erro: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
